import { z } from 'zod';
/**
 * Upper bound on the injected markup. Generous enough for several script
 * tags plus inline snippets, but bounded so a single super admin can't
 * stuff an unbounded blob that ships to every dashboard visitor.
 */
const MAX_HEAD_HTML = 20000;
/**
 * Body for `PUT /v1/admin/dashboard-scripts`.
 *
 * `headHtml` is raw markup injected verbatim into the customer dashboard
 * <head>. It is intentionally NOT sanitized — this is a trusted super-admin
 * surface (the route is gated by `requireAdmin`). `enabled` gates whether
 * the public endpoint serves it at all, so admins can stage HTML while it's
 * turned off.
 */
export const AdminDashboardScriptsInput = z.object({
    enabled: z.boolean(),
    headHtml: z.string().max(MAX_HEAD_HTML).default(''),
});
/**
 * What `GET /v1/admin/dashboard-scripts` returns to the super-admin UI.
 */
export const AdminDashboardScriptsDTO = z.object({
    enabled: z.boolean(),
    headHtml: z.string(),
    updatedBy: z.string().uuid().nullable(),
    updatedAt: z.string(),
});
/**
 * What the unauthenticated `GET /v1/config/dashboard-scripts` returns. Used
 * by the dashboard SPA to decide whether to inject markup. When
 * `enabled = false`, `headHtml` is an empty string so nothing is injected.
 */
export const PublicDashboardScriptsDTO = z.object({
    enabled: z.boolean(),
    headHtml: z.string(),
});
//# sourceMappingURL=dashboardScripts.js.map